import { render, staticRenderFns } from "./soporteSolicitar.vue?vue&type=template&id=f0c6e04a&scoped=true&"
import script from "./soporteSolicitar.vue?vue&type=script&lang=js&"
export * from "./soporteSolicitar.vue?vue&type=script&lang=js&"
import style0 from "./soporteSolicitar.vue?vue&type=style&index=0&id=f0c6e04a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c6e04a",
  null
  
)

export default component.exports